import React from "react";
import { Lightbulb, Shield, Zap, Users, Heart, Settings } from "lucide-react";

export default function WhatDrivesUs() {
  const values = [
    {
      icon: Lightbulb,
      title: "Innovation",
      description:
        "We embrace cutting-edge technologies and creative thinking to deliver solutions that push boundaries and exceed expectations.",
    },
    {
      icon: Shield,
      title: "Integrity",
      description:
        "We build trust through transparency, honesty, and ethical practices in all our client relationships and business operations.",
    },
    {
      icon: Zap,
      title: "Excellence",
      description:
        "We strive for perfection in every project, continuously improving our skills and processes to deliver outstanding results.",
    },
    {
      icon: Users,
      title: "Collaboration",
      description:
        "We believe in the power of teamwork, fostering partnerships that bring out the best in everyone involved.",
    },
    {
      icon: Heart,
      title: "Passion",
      description:
        "We are genuinely passionate about technology and its potential to transform businesses and improve lives.",
    },
    {
      icon: Settings,
      title: "Adaptability",
      description:
        "We embrace change and continuously evolve to meet the dynamic needs of our clients and the technology landscape.",
    },
  ];

  return (
    <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span className="inline-block bg-blue-100 text-blue-600 px-6 py-2 rounded-full text-sm font-medium mb-6">
            OUR VALUES
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            What Drives Us
          </h1>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Our core values shape everything we do and guide us in delivering
            exceptional results for our clients.
          </p>
        </div>

        {/* Values Grid - Responsive with horizontal scroll on mobile */}
        <div className="overflow-x-auto pb-4 -mx-4 px-4 lg:overflow-visible">
          <div className="flex gap-6 min-w-max md:min-w-0 md:grid md:grid-cols-2 lg:grid-cols-3">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div
                  key={index}
                  className="flex-shrink-0 w-80 md:w-auto text-center"
                >
                  {/* Icon */}
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-500 text-white rounded-2xl mb-6">
                    <Icon size={32} strokeWidth={2} />
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    {value.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Scroll indicator for mobile/tablet when applicable */}
        <div className="md:hidden text-center mt-6">
          <p className="text-sm text-gray-500">← Swipe to see more →</p>
        </div>
      </div>
    </div>
  );
}
